import styled from '@emotion/styled'

import { Column, ResultTable, Space } from '../../../components/core-v2'
import { formatCurrencyFull } from '../../../utilities/currency'

type UsageList = {
  tradeName: string
  usage: string
}

type UsageInput = {
  tradeUsages: Record<string, number>
}

const StyledWrapper = styled.div`
  table {
    th {
      background: var(--White);
      &:last-of-type {
        text-align: right;
      }
    }
    td {
      padding: 16px 8px;
      border-left: none;
      border-top: none;
      &:last-of-type {
        text-align: right;
      }
    }
  }
`

export const UsageTab = ({ tradeUsages }: UsageInput) => {
  const usages: UsageList[] = []
  let total = 0
  for (const x in tradeUsages) {
    usages.push({
      tradeName: x,
      usage: formatCurrencyFull(tradeUsages[x], 'ZAR')
    })

    total += tradeUsages[x]
  }
  const columns: Column<UsageList>[] = [
    {
      name: 'tradeName',
      title: 'Name'
    },
    {
      name: 'usage',
      title: `Total value (${formatCurrencyFull(total, 'ZAR')})`
    }
  ]

  return (
    <Space mx={5} py={6}>
      <StyledWrapper>
        <ResultTable columns={columns} data={usages} />
      </StyledWrapper>
    </Space>
  )
}
